
import PropTypes from 'prop-types'
import moment from 'moment'

import TableRow from '@mui/material/TableRow'
import TableCellView from 'frame/components/table-cell/table-cell'
import { getFuelExceptionColor } from 'listable'
import { createRowSelector } from 'utils'
import Checkbox from '@mui/material/Checkbox'
import {
  isSelectableStatus,
  toExceptionKey
} from '../../common/exception-utils'

const formatDate = (d) => (d ? moment(d).format('DD/MM/YYYY') : '-')

const notePreviewStyle = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
}

const Row = ({
  item,
  columns,
  onView,
  checked,
  onToggleSelect,
  exceptionKey,
}) => {
  const onSafeRowClick = createRowSelector(onView)
  const selectable = isSelectableStatus(item.status)
  const resolvedExceptionKey = exceptionKey || toExceptionKey(item)
  const onCheckboxClick = (e) => {
    e.stopPropagation()
    if (selectable && typeof onToggleSelect === 'function') {
      onToggleSelect(resolvedExceptionKey)
    }
  }

  return (
    <TableRow
      hover
      sx={{ height: '32px', borderBottom: '5px solid white' }}
      onClick={onSafeRowClick}>
      <TableCellView>{item.id}</TableCellView>
      <TableCellView sx={{ px: 0 }}>
        <Checkbox
          size="small"
          checked={!!checked}
          disabled={!selectable}
          onClick={onCheckboxClick}
          sx={{ p: 0 }}/>
      </TableCellView>
      {columns.transactionDate && (
        <TableCellView>{formatDate(item.transactionDate)}</TableCellView>
      )}
      {columns.thirdPartyNumber && (
        <TableCellView>{item.thirdPartyNumber || '-'}</TableCellView>
      )}
      {columns.agreementNumber && (
        <TableCellView>{item.agreementNumber || '-'}</TableCellView>
      )}
      {columns.customerName && (
        <TableCellView>{item.customerName || '-'}</TableCellView>
      )}
      {columns.status && (
        <TableCellView>
          <span
            style={{
              color: getFuelExceptionColor(item.status),
              fontSize: '13px',
              fontWeight: 500,
            }}>
            {item.status ?? 'Pending Review'}
          </span>
        </TableCellView>
      )}
      {columns.vehicleRegistration && (
        <TableCellView>{item.vehicleRegistration || '-'}</TableCellView>
      )}
      {columns.vehicleDescription && (
        <TableCellView>{item.vehicleDescription || '-'}</TableCellView>
      )}
      {columns.manufacturerDescription && (
        <TableCellView>{item.manufacturerDescription || '-'}</TableCellView>
      )}
      {columns.driverName && (
        <TableCellView>{item.driverName || '-'}</TableCellView>
      )}
      {columns.exception && (
        <TableCellView>{item.exception || '-'}</TableCellView>
      )}
      {columns.costCentre && (
        <TableCellView>{item.costCentre || '-'}</TableCellView>
      )}
      {columns.locationName && (
        <TableCellView>{item.locationName || '-'}</TableCellView>
      )}
      {columns.fleetController && (
        <TableCellView>{item.fleetController || '-'}</TableCellView>
      )}
      {columns.latestNoteText && (
        <TableCellView isLast>
          <div style={notePreviewStyle}>{item.latestNoteText || ''}</div>
        </TableCellView>
      )}
    </TableRow>
  )
}

Row.propTypes = {
  item: PropTypes.object.isRequired,
  columns: PropTypes.object.isRequired,
  onView: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  onToggleSelect: PropTypes.func,
  exceptionKey: PropTypes.string,
}

Row.defaultProps = {
  checked: false,
}

export default Row
